module.exports = __webpack_public_path__ + "img/star1-new-end.21c2a4d9.svg";